export default __webpack_public_path__ + "static/media/classic-desktop.a6fc46c3.jpg";